/**
 * `ChartHeader`'s boxes as classes, kept out of the component file so a route's pending skeleton
 * — which must not import a component module — draws the very same grid and switches at the
 * very same container width.
 *
 * The owner's ruling 3 (2026-10-28, COMPARE-ov §1a): two columns, top-aligned, 16 apart. Left, the
 * title over the value row, 8 apart. Right, flush right: the Line/Candles toggle and the chart
 * button on one row, the boxed periods 8 under it. Under `@xl/chart-head` (36rem, where the two
 * columns stop fitting side by side) the right column drops under the value row at full width:
 * the toggle left and the chart button right, then 16 down, the periods scrolling sideways.
 *
 * A chart with periods and no toggle or button (`bare`) keeps them on one row, the note leading:
 * top-right beside the figure, or under it at full width below `@xl`.
 */
export const CHART_HEAD = {
  root: '@container/chart-head',
  grid: 'grid grid-cols-1 gap-4 @xl/chart-head:grid-cols-[1fr_auto] @xl/chart-head:items-start',
  info: 'flex min-w-0 flex-col gap-2',
  actions: 'flex min-w-0 flex-col gap-4 @xl/chart-head:items-end @xl/chart-head:gap-2',
  controls: 'flex items-center gap-2',
  bare: 'flex min-w-0 items-center gap-3 @xl/chart-head:justify-end',
  // `-my-2`/`py-2` cancel out, leaving the scroller room for the focus ring and the sub-`lg`
  // touch-target growth without adding height.
  periods:
    'scrollbar-slim -my-2 min-w-0 overflow-x-auto overscroll-x-contain py-2 @xl/chart-head:my-0 @xl/chart-head:overflow-visible @xl/chart-head:py-0',
} as const

/** The chart's distance under the header: 24 below the taller column. */
export const CHART_UNDER_HEAD = 'mt-6'
